export const DIMENSIONS = {
  counterTypeHandler: ['Business Process', 'Agent', 'Campaign', 'Callback', 'Channel', 'Organization']
};
